<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="about-the-author">
<h1>About the Author</h1>
<p>Gordon S. Dickson was born near Inverness, Scotland, but left at an early age when his family returned to Northern Ireland. He was educated at secondary and grammar schools, but scraped through English O Level, as essay writing was not his strength. He was employed in the Civil Service for several years but is now retired and has only recently taken up writing books.</p><br/>
<p>He enjoys reading several genres of books but mainly historical and detective novels, and a little gardening.</p><br/>
<p>Other books by this author are:</p>
<p><em>Verdict Unknown</em></p>
<p><em>Verdict Unknown, the Sequel</em></p>
<p><em>The Sheriff of River Bend</em></p>
<p><em>Des Pond, Special Agent (Comedy)</em></p>
<p><em>The Wartime Adventures of Harry Harris (A Bartonshire Tale 1)</em></p>
<p><em>An Impossible Quest (A Bartonshire Tale 2)</em></p>
<p><em>The Life and Times of Victoria-Ann Penny</em></p>
<p><em>The Heir… Apparently, and Ashes to Ashes (A Bartonshire tale 3)</em></p>
<p><em>The Spanish Armada. What if it had all gone wrong?</em></p>
<p><em>Detective Inspector Denison Stories. The Imposter &amp; The Informers’ Murders.</em></p>
<p><em><br/>
</em></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch001.vue?5b15d144